module.exports = __webpack_public_path__ + "static/media/Back Office Manual.7cdfd254.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/Back Office Manual.pdf
// module id = 784
// module chunks = 0